import React from "react";
import "./Terms.css";

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: January 2024</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Go With Me Buddy ("the Platform"), you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to these Terms of Service, please do not use our services.
            </p>
          </section>

          <section>
            <h2>2. Use of Service</h2>
            <p>
              Go With Me Buddy is a platform designed to connect travelers and facilitate trip planning. You agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information when creating your account</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the platform only for lawful purposes</li>
              <li>Not impersonate any person or entity</li>
              <li>Not transmit any harmful or malicious content</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>
              To access certain features of the Platform, you must register for an account. You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account password</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>
          </section>

          <section>
            <h2>4. User Content</h2>
            <p>
              You retain all rights to content you submit to the Platform. By posting content, you grant us a 
              non-exclusive, worldwide, royalty-free license to use, display, and distribute your content in 
              connection with operating the service.
            </p>
          </section>

          <section>
            <h2>5. Travel Partners and Agencies</h2>
            <p>
              Go With Me Buddy facilitates connections between travelers and provides information about travel agencies. 
              We are not responsible for:
            </p>
            <ul>
              <li>The actions or conduct of other users or agencies</li>
              <li>Any agreements made between users</li>
              <li>The quality or safety of trips organized through the platform</li>
              <li>Financial transactions between users and agencies</li>
            </ul>
          </section>

          <section>
            <h2>6. Privacy</h2>
            <p>
              Your use of the Platform is also governed by our Privacy Policy. Please review our Privacy Policy to 
              understand our practices regarding the collection and use of your personal information.
            </p>
          </section>

          <section>
            <h2>7. Prohibited Activities</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Violate any laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Post false or misleading information</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Attempt to gain unauthorized access to the Platform</li>
              <li>Use automated systems to access the Platform</li>
            </ul>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Go With Me Buddy shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages resulting from your use of the Platform.
            </p>
          </section>

          <section>
            <h2>9. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account at any time for violations of these Terms 
              or for any other reason at our sole discretion.
            </p>
          </section>

          <section>
            <h2>10. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of the Platform after changes constitutes 
              acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2>11. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="contact-info">
              Email: gowithmebuddy1@gmail.com<br />
              Address: Gurgaon, Haryana
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
